import React from "react";
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useTranslation } from "react-i18next";

const LanguageToggle = () => {
    const { i18n } = useTranslation();
    const currentLang = i18n.language;

    const handleChange = (_, newLang) => {
        if (newLang) i18n.changeLanguage(newLang);
    };

    return (
        <Box sx={{ display: "flex", justifyContent: "center", px: 2, pb: 1 }}>
            <ToggleButtonGroup
                value={currentLang}
                exclusive
                onChange={handleChange}
                size="small"
                sx={{
                    backgroundColor: "rgba(255, 255, 255, 0.08)",
                    borderRadius: "8px",
                    "& .MuiToggleButton-root": {
                        color: "text.primary",
                        border: "none",
                        px: 1.5,
                        py: 0.5,
                        fontSize: "0.75rem",
                        "&.Mui-selected": {
                            bgcolor: "primary.main",
                            color: "white",
                            "&:hover": {
                                bgcolor: "primary.dark",
                            },
                        },
                    },
                }}
            >
                <ToggleButton value="en">EN</ToggleButton>
                <ToggleButton value="ro">RO</ToggleButton>
            </ToggleButtonGroup>
        </Box>
    );
};

export default LanguageToggle;